import React from 'react';
import Tooltip from './Tooltip';

/**
 * Compact validation errors for bulk job tables — red text + #fef2f2 when errors exist,
 * amber when only info (same pattern as Batch Validation).
 */
export default function RowValidationErrorsCell({
  validationErrors = [],
  validationErrorInfo,
  maxLen = 35,
}) {
  const parts = [
    ...(validationErrors || []),
    ...(validationErrorInfo != null && validationErrorInfo !== ''
      ? [typeof validationErrorInfo === 'object' ? JSON.stringify(validationErrorInfo) : String(validationErrorInfo)]
      : []),
  ].filter((p) => p !== null && p !== undefined && String(p).trim() !== '');

  if (parts.length === 0) {
    return <span style={{ color: '#9ca3af', fontSize: '12px' }}>-</span>;
  }

  const combined = parts.join(' • ');
  const hasErrors = validationErrors && validationErrors.length > 0;
  const color = hasErrors ? '#dc2626' : '#d97706';
  const bg = hasErrors ? '#fef2f2' : '#fffbeb';

  if (combined.length <= maxLen) {
    return (
      <span
        style={{
          fontSize: '11px',
          color,
          background: bg,
          padding: '2px 7px',
          borderRadius: '3px',
          whiteSpace: 'nowrap',
          display: 'inline-block',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {combined}
      </span>
    );
  }

  return (
    <Tooltip text={parts.join('\n')} position="bottom">
      <span
        style={{
          fontSize: '11px',
          color,
          background: bg,
          padding: '2px 7px',
          borderRadius: '3px',
          whiteSpace: 'nowrap',
          display: 'inline-block',
          maxWidth: '190px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          cursor: 'default',
          verticalAlign: 'middle',
        }}
      >
        {combined.substring(0, maxLen)}...
      </span>
    </Tooltip>
  );
}
